export const OPEN_ORDER_IN_LT_MANAGER = 'OPEN_ORDER_IN_LT_MANAGER';
export const OPEN_ORDER_IN_LT_MANAGER_SUCCESS =
  'OPEN_ORDER_IN_LT_MANAGER_SUCCESS';
export const OPEN_ORDER_IN_LT_MANAGER_FAILURE =
  'OPEN_ORDER_IN_LT_MANAGER_FAILURE';

export const openOrderInLtManager = (orderId: number) => ({
  type: OPEN_ORDER_IN_LT_MANAGER,
  payload: { orderId },
});
